exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge-discrete-legend[data-v-48ded95e] {\n  border: 2px solid;\n  padding: 0.25em 0.4em;\n  line-height: 1;\n  text-align: center;\n  border-radius: 0.25rem;\n}\n", ""]);

// exports
